import { Vue, Component, namespace } from 'nuxt-property-decorator';
const pageStore = namespace('page');

@Component
export default class AdsSuperbanner extends Vue {
  @pageStore.Getter readonly isImmowelt!: boolean;
  @pageStore.Getter readonly isImmoweltAt!: boolean;
}
